import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";

type SubMenus = "ASSIGNED_TO_ME" | "STARTED_BY_ME" | "PARTICIPATED_IN" | "ADMIN_SETTINGS";

export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "WORKFLOW")?.children;
    const subModules = mainModuleChildren ? (mainModuleChildren.map((m) => m.module) as SubMenus[]) : null;
    const config = [
      {
        label: <MenuItemWithBadge label={`Assigned to me`} />,
        link: "assignments",
      },
      {
        label: <MenuItemWithBadge label={`Started by me`} />,
        link: "started-by-me",
      },
      {
        label: <MenuItemWithBadge label={`Participated in`} />,
        link: "worked-on",
      },
    ];

    if (subModules?.includes("ADMIN_SETTINGS")) {
      config.push({
        label: <MenuItemWithBadge label={`Admin settings`} />,
        link: "admin",
      });
    }

    return config;
  },
};
